<template>
  <div class="Keyboard">
    <Button v-for="key in keys" class="key" :severity="key.severity ?? 'secondary'"
      :class="key.class"
      :disabled="key.disabled"
      @click="onClick(key)"
    >
      {{ key.disabled ? "" : key.text }}
    </Button>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";

const props = defineProps([
  "disabledKeys",
  "disableControlKeys"
]);

const emit = defineEmits([
  "ok",
  "cancel",
  "keypress",
  "backspace",
]);

const disabledKeys = computed(() => {
  let controlKeys = [ "Tab", "Caps Lock", "Enter", "Ctrl", "Alt", "Fn", "Cmd" ];
  if (props.disableControlKeys)
    return controlKeys;
  else
    return props.disabledKeys ?? [];
});

const keysInitial = [
  { text: "~" },
  { text: "1" },
  { text: "2" },
  { text: "3" },
  { text: "4" },
  { text: "5" },
  { text: "6" },
  { text: "7" },
  { text: "8" },
  { text: "9" },
  { text: "0" },
  { text: "-" },
  { text: "+" },
  { text: "Backspace", class: "backspace", handler: () => emit("backspace") },
  { text: "Tab", class: "tab", handler: () => {} },
  { text: "q" },
  { text: "w" },
  { text: "e" },
  { text: "r" },
  { text: "t" },
  { text: "y" },
  { text: "u" },
  { text: "i" },
  { text: "o" },
  { text: "p" },
  { text: "[" },
  { text: "]" },
  { text: "\\", class: "backslash" },
  { text: "Caps Lock", class: "capslock", handler: () => {} },
  { text: "a" },
  { text: "s" },
  { text: "d" },
  { text: "f" },
  { text: "g" },
  { text: "h" },
  { text: "j" },
  { text: "k" },
  { text: "l" },
  { text: ";" },
  { text: "'" },
  { text: "Enter", class: "return", handler: () => {} },
  { text: "Shift", class: "leftshift", handler: () => isShiftPressed.value = !isShiftPressed.value  },
  { text: "z" },
  { text: "x" },
  { text: "c" },
  { text: "v" },
  { text: "b" },
  { text: "n" },
  { text: "m" },
  { text: "," },
  { text: "." },
  { text: "/" },
  { text: "Shift", class: "rightshift", handler: () => isShiftPressed.value = !isShiftPressed.value },
  { text: "Ctrl", class: "leftctrl", handler: () => {} },
  { text: "Cmd", class: "command", handler: () => {} },
  { text: "Alt", class: "alt", handler: () => {} },
  { text: " ", class: "space" },
  // { text: "Alt", class: "alt", handler: () => {} },
  // { text: "Fn" },
  // { text: "Cmd", class: "command", handler: () => {} },
  // { text: "Ctrl", class: "rightctrl", handler: () => {} }
  { text: "Ok", class: "ok", severity: "primary", handler: () => emit("ok") },
  { text: "Cancel", class: "cancel", handler: () => emit("cancel") }
];

const isShiftPressed = ref(true);

const keys = computed(() => {
  return keysInitial.map(key => {
    let isLetter = ("abcdefghijjklmnopqrstuvwxyz").includes(key.text);
    let text = (isLetter && isShiftPressed.value) ? key.text.toUpperCase() : key.text;
    return {
      ... key,
      text,
      disabled: disabledKeys.value.includes(key.text)
    };
  });
});

function onClick(key) {
  if (key.handler)
    key.handler();
  else
    emit("keypress", key.text);

  if (key.text != "Shift")
    isShiftPressed.value = false;
}

</script>

<style scoped>
.Keyboard {
  display: grid;
  grid-template-columns: repeat(30, 25px);
  grid-template-rows: repeat(5, 50px);
  grid-gap: 5px;
}
.key {
  grid-column: span 2;
  /* background-color: rgb(243, 243, 243);
  border: 2px solid black;
  border-radius: 5px;
  font-size: 20px;
  text-align: center;
  padding-top: 17px; */
}
.backspace {
  grid-column: span 4;
}
.tab {
  grid-column: span 3;
}
.backslash {
  grid-column: span 3;
}
.capslock {
  grid-column: span 4;
}
.return {
  grid-column: span 4;
}
.leftshift {
  grid-column: span 5;
}
.rightshift {
  grid-column: span 5;
}
.leftctrl {
  grid-column: span 3;
}
.rightctrl {
  grid-column: span 2;
}
.command {
  grid-column: span 3;
  font-size: 14px;
}
.space {
  grid-column: span 13;
}
.ok {
  grid-column: span 4;
}
.cancel {
  grid-column: span 5;
}
</style>